import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'dmmp-subcontent-view',
  templateUrl: './subcontent-view.component.html'
})
export class SubcontentViewComponent implements OnInit {

  @Input() title
  @Input() title_class
  @Input() title_hidden
  @Input() body
  @Input() image
  @Input() image_class
  @Input() icon
  @Input() identifier
  @Input() image_on_text
  @Input() separator

  medias = [
    {style: 'large', media: '(min-width:421px)'},
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
